class declareDetailCtrl {
    constructor($scope, httpRequest, initSortService) {
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                allotPointCode: '',
                collectPointCode: '',
                endDate: '',
                invoiceType: '',
                receivePointCode: '',
                refundMode: '',
                startDate: '',

                applyWay: '',
                dealDateEnd: '',
                dealDateStart: '',
                invoiceTypeCode: '',
                invoiceTypeName: '',
                operateStatus: '',
                saleCreditCode: '',


            },
        }
        // 查询条件
        function init() {
            $scope.param.param = {
                allotPointCode: '',
                collectPointCode: '',
                endDate: '',
                invoiceType: '',
                receivePointCode: '',
                refundMode: '',
                startDate: '',

                applyWay: '',
                dealDateEnd: '',
                dealDateStart: '',
                invoiceTypeCode: '',
                invoiceTypeName: '',
                operateStatus: '',
                saleCreditCode: '',
            }
        }
        // init()
        $scope.reset = init

        // 默认查询值
        $scope.profileType = '24'

        // 表头排序
        $scope.sortIndexStorageName = 'declareDetailSortIndex24'
        $scope.orderMap = initSortService($scope.profileType == '24' ? 'declareParam24' : ($scope.profileType == '25' ? 'declareParam25' : 'declareParam26'))
        $scope.sortIndex = sessionStorage[$scope.sortIndexStorageName] ? sessionStorage[$scope.sortIndexStorageName] : ''
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            if ($scope.profileType == '24') {
                sessionStorage.setItem('declareParam24', JSON.stringify($scope.param))
            }
            if ($scope.profileType == '25') {
                sessionStorage.setItem('declareParam25', JSON.stringify($scope.param))
            }
            if ($scope.profileType == '26') {
                sessionStorage.setItem('declareParam26', JSON.stringify($scope.param))
            }
            $scope.queryTaxInfo()
        }

        // 日期初始化
        $scope.datepickerConfig = {
            minView: 'month', // 选择日期后，不会再跳转去选择时分秒
            format: 'yyyy-mm-dd',
        }
        // 获取发票类型
        $scope.invoiceTypeList = [{
            invoiceTypeCode: '',
            invoiceTypeName: '全部',
        }]
        httpRequest.get_queryInvoiceTypeName().then((res) => {
            if (res.data.value && res.data.value.length > 0) {
                $scope.invoiceTypeList = $scope.invoiceTypeList.concat(res.data.value)
            }
        })
        // 获取所有金税盘作为
        $scope.diskList = []
        $scope.diskList[0] = {
            diskCode: '',
            diskName: '全部',
        }
        httpRequest.get_getDiskBySaleId({
            saleId: $scope.pageState.userInfo.sale.saleId,
        }).then((res) => {
            var res = res.data.value
            res = res.filter((item) => item.diskType === 1 || item.diskCode === '0')
            if (res.length > 0) {
                $scope.diskList = $scope.diskList.concat(res)
                // 获取当前条件下所有领票点
                const req = $scope.diskList.map((item) => item.diskCode).filter((item) => item !== '')
                httpRequest.post_getUkeyListByDiskCodes(req).then((res1) => {
                    if (res1.data.value && res1.data.value.length > 0) {
                        $scope.ukeyList = $scope.ukeyList.concat(res1.data.value)
                    }
                })
            }
        })
        $scope.allotPointChange = function (v) {
            let req = []
            if (v !== '') {
                req[0] = v
            } else {
                req = $scope.diskList.map((item) => item.diskCode).filter((item) => item !== '')
            }
            $scope.ukeyList = [{
                diskCode: '',
                diskCodeName: '全部',
            }]
            httpRequest.post_getUkeyListByDiskCodes(req).then((res) => {
                if (res.data.value && res.data.value.length > 0) {
                    $scope.ukeyList = $scope.ukeyList.concat(res.data.value)
                }
            })
        }
        // 领票点
        $scope.ukeyList = []
        $scope.ukeyList[0] = {
            diskCode: '',
            diskCodeName: '全部',
        }
        // 分页数
        $scope.totalItems = 0 // 组件初始化设置总页
        $scope.$on('$stateChangeStart', () => {
            sessionStorage.removeItem('declareParam24')
            sessionStorage.removeItem('declareParam25')
            sessionStorage.removeItem('declareParam26')
            sessionStorage.removeItem('declareDetailSortIndex24')
            sessionStorage.removeItem('declareDetailSortIndex25')
            sessionStorage.removeItem('declareDetailSortIndex26')
        })
        // 查询列表
        $scope.queryTaxInfo = function () {
            $scope.resData = []
            if ($scope.profileType == '24') {
                $scope.param = sessionStorage.declareParam24 ? JSON.parse(sessionStorage.declareParam24) : $scope.param
                httpRequest.post_queryOvatOnlineApplyRecordDetail($scope.param).then((res) => {
                    $scope.resData = res.data.value.list
                    // 获取后台分页数据 回写分页组件
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                })
            }
            if ($scope.profileType == '25') {
                $scope.param = sessionStorage.declareParam25 ? JSON.parse(sessionStorage.declareParam25) : $scope.param
                const openLoading1 = $scope.param.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                }) : null
                httpRequest.post_getInvoiceAllotDetails($scope.param).then((res) => {
                    $scope.resData = res.data.value.list
                    // 获取后台分页数据 回写分页组件
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                }).finally(() => {
                    window.layer.close(openLoading1)
                })
            }
            if ($scope.profileType == '26') {
                $scope.param = sessionStorage.declareParam26 ? JSON.parse(sessionStorage.declareParam26) : $scope.param
                const openLoading2 = $scope.param.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                }) : null
                httpRequest.post_getInvoiceCollectDetails($scope.param).then((res) => {
                    $scope.resData = res.data.value.list
                    // 获取后台分页数据 回写分页组件
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                }).finally(() => {
                    window.layer.close(openLoading2)
                })
            }
        }
        $scope.searchList = function () {
            if ($scope.profileType == '24') {
                sessionStorage.setItem('declareParam24', JSON.stringify($scope.param))
            }
            if ($scope.profileType == '25') {
                sessionStorage.setItem('declareParam25', JSON.stringify($scope.param))
            }
            if ($scope.profileType == '26') {
                sessionStorage.setItem('declareParam26', JSON.stringify($scope.param))
            }
            $scope.queryTaxInfo()
        }
        $scope.pageChanged = function () { // 点击页码发起查询
            const paramObj = {
                allotPointCode: '',
                collectPointCode: '',
                endDate: '',
                invoiceType: '',
                receivePointCode: '',
                refundMode: '',
                startDate: '',

                applyWay: '',
                dealDateEnd: '',
                dealDateStart: '',
                invoiceTypeCode: '',
                invoiceTypeName: '',
                operateStatus: '',
                saleCreditCode: '',
            }
            if ($scope.profileType == '24') {
                sessionStorage.setItem('declareParam24', JSON.stringify(
                    {
                        orderMap: $scope.param.orderMap,
                        pageNum: $scope.param.pageNum,
                        pageSize: $scope.param.pageSize,
                        param: sessionStorage.declareParam24 ? JSON.parse(sessionStorage.declareParam24).param : paramObj,
                    },
                ))
            }
            if ($scope.profileType == '25') {
                sessionStorage.setItem('declareParam25', JSON.stringify(
                    {
                        orderMap: $scope.param.orderMap,
                        pageNum: $scope.param.pageNum,
                        pageSize: $scope.param.pageSize,
                        param: sessionStorage.declareParam25 ? JSON.parse(sessionStorage.declareParam25).param : paramObj,
                    },
                ))
            }
            if ($scope.profileType == '26') {
                sessionStorage.setItem('declareParam26', JSON.stringify(
                    {
                        orderMap: $scope.param.orderMap,
                        pageNum: $scope.param.pageNum,
                        pageSize: $scope.param.pageSize,
                        param: sessionStorage.declareParam26 ? JSON.parse(sessionStorage.declareParam26).param : paramObj,
                    },
                ))
            }
            $scope.queryTaxInfo()
        }
        // tab变化
        $scope.tabChange = function (index) {
            $scope.param.pageNum = 1
            $scope.reset()
            // 初始化查询和表格控件实例
            switch (index) {
            case 25:
                $scope.profileTypeObj = {
                    version: 2,
                    queryConfig: [
                        {
                            label: '发票种类',
                            selected: true,
                            default: true,
                        }, {
                            label: '分票时间',
                            selected: true,
                            default: true,
                        }, {
                            label: '分票点',
                            selected: true,
                            default: true,
                        }, {
                            label: '领票点',
                            selected: true,
                            default: true,
                        },
                    ],
                    table: [
                        {
                            label: '发票种类',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceType', dictFilter: 'stock_inv_type' }],
                        }, {
                            label: '分票数量',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceCount' }],
                        }, {
                            label: '类别代码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceTypeCode' }],
                        }, {
                            label: '起始号码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceNumberStart' }],
                        }, {
                            label: '状态',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'devisionStatus', dictFilter: 'devision_status' }],
                        }, {
                            label: '分票点',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'orgDiskCodeAllot' }],
                        }, {
                            label: '分票时间',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'devisionDate' }],
                        }, {
                            label: '领票点',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'orgDiskCodeRecieve' }],
                        }, {
                            label: '分票人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'orgUserAllot' }],
                        }, {
                            label: '领票人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'orgUserReciece' }],
                        }, {
                            label: '领票时间',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'receiveDate' }],
                        },
                    ],
                }
                break
            case 26:
                $scope.profileTypeObj = {
                    version: 2,
                    queryConfig: [
                        {
                            label: '发票种类',
                            selected: true,
                            default: true,
                        }, {
                            label: '收回时间',
                            selected: true,
                            default: true,
                        }, {
                            label: '收票点',
                            selected: true,
                            default: true,
                        },
                    ],
                    table: [
                        {
                            label: '发票种类',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceType', dictFilter: 'stock_inv_type' }],
                        }, {
                            label: '数量',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceCount' }],
                        }, {
                            label: '类别代码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceTypeCode' }],
                        }, {
                            label: '起始号码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceNumberStart' }],
                        }, {
                            label: '退票方式',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'backType', dictFilter: 'back_type' }],
                        }, {
                            label: '状态',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'backStatus', dictFilter: 'back_status' }],
                        }, {
                            label: '退票点',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'orgCodeCallback' }],
                        }, {
                            label: '收回点',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'orgCodeTakeback' }],
                        }, {
                            label: '退票人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'orgPersonCallback' }],
                        }, {
                            label: '退票时间',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'backDate' }],
                        }, {
                            label: '收回人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'orgPersonTakeback' }],
                        }, {
                            label: '收回时间',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'receiveDate' }],
                        },
                    ],
                }
                break
            default:
                $scope.profileTypeObj = {
                    version: 3,
                    queryConfig: [
                        {
                            label: '发票种类名称',
                            selected: true,
                            default: true,
                        }, {
                            label: '购票时间',
                            selected: true,
                            default: true,
                        }, {
                            label: '状态',
                            selected: true,
                            default: true,
                        }, {
                            label: '领票方式',
                            selected: true,
                            default: true,
                        },
                    ],
                    table: [
                        {
                            label: '发票种类名称',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceTypeName' }],
                        }, {
                            label: '领购数量',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'applyCount' }],
                        }, {
                            label: '类别代码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceTypeCode' }],
                        }, {
                            label: '起始号码',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'invoiceNumberStart' }],
                        }, {
                            label: '领票方式',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'applyWay', dictFilter: 'apply_way' }],
                        }, {
                            label: '状态',
                            selected: true,
                            default: true,
                            labelContent: [{ labelWord: 'operateStatus', dictFilter: 'operate_status' }],
                        }, {
                            label: '申请时间',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'applyDate' }],
                        }, {
                            label: '购票时间',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'dealDate' }],
                        }, {
                            label: '操作人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'updateUser' }],
                        }, {
                            label: '收件人',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'consigneeName' }],
                        }, {
                            label: '手机号码',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'mobile' }],
                        }, {
                            label: '快递地址',
                            selected: false,
                            default: false,
                            labelContent: [{ labelWord: 'addressInfo' }],
                        },
                    ],
                }
            }

            $scope.profileType = `${index}`
            $scope.sortIndexStorageName = `declareDetailSortIndex${index}`
            $scope.sortIndex = sessionStorage[$scope.sortIndexStorageName] ? sessionStorage[$scope.sortIndexStorageName] : $scope.sortIndex
            // 当前tab没有sessionStorage时，会保持上次排序进行查询，进行相应高亮
            const orderMap1 = initSortService(index == '24' ? 'declareParam24' : (index == '25' ? 'declareParam25' : 'declareParam26'))
            if (orderMap1.sortKey) $scope.orderMap = orderMap1
            $scope.queryTaxInfo()
        }
        $scope.tabChange(24)
    }
}


declareDetailCtrl.$inject = ['$scope', 'httpRequest', 'initSortService']
export default declareDetailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/details/declareDetailCtrl.js